import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';
import { useQuery } from '@tanstack/react-query';
import { API } from 'api';

import { apiBasePath, apiName } from 'assets';

export interface KeyInsightsSection {
  id: number;
  name: string;
  display_title: string;
  short_description?: string;
  priority?: number;
}

export const getKeyInsightsSections = async (kitId?: string) => {
  const kitFetchParam = kitId ? `/${kitId}` : '';

  const response = await API.get(
    apiName,
    `${apiBasePath}/results/key-insights-sections${kitFetchParam}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.INSIGHTS,
        importance: IMPORTANCE.CRITICAL,
      },
    },
  );
  return response?.sections ?? [];
};

const useKeyInsightsSections = (kitId?: string) => {
  const keyInsightsSectionsQuery = useQuery<KeyInsightsSection[]>({
    queryKey: [apiName, 'KeyInsightsSections', kitId],
    queryFn: async () => await getKeyInsightsSections(kitId),
  });

  return keyInsightsSectionsQuery;
};

export default useKeyInsightsSections;
